import React from 'react';
import { Button } from 'antd';
import { SoundOutlined, CloseOutlined } from '@ant-design/icons';
import moment from 'moment';

const AnnouncementBanner = ({ announcements = [], onClose }) => {
  if (!announcements || announcements.length === 0) return null;

  const announcement = announcements[0];

  return (
    <div style={{
      position: 'fixed',
      top: window.innerWidth < 992 ? '100px' : '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
      maxWidth: '600px',
      width: '90%',
      maxHeight: '200px',
      overflowY: 'auto',
      background: 'linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%)',
      borderRadius: '8px',
      padding: '12px 16px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      border: '2px solid #ffd591'
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <SoundOutlined style={{ color: '#faad14', fontSize: '20px', marginTop: '2px' }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '13px', fontWeight: 600, color: '#262626', marginBottom: '4px' }}>
            📢 Latest Announcement
          </div>
          <div style={{ fontSize: '14px', color: '#595959', marginBottom: '4px' }}>
            {announcement.message}
          </div>
          <div style={{ fontSize: '11px', color: '#8c8c8c', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>From: {announcement.user_name}</span>
            <span>•</span>
            <span>{moment(announcement.timestamp).format('MMM DD, hh:mm A')}</span>
          </div>
        </div>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={onClose}
          style={{ color: '#8c8c8c' }}
        />
      </div>
    </div>
  );
};

export default AnnouncementBanner;
